<ng-container *ngIf="isOpen$ | async as isOpen">
  <!-- Scrim / overlay -->
  <div class="myce-mobile-nav__scrim"
       [class.myce-mobile-nav__scrim--visible]="isOpen"
       (click)="onScrimClick()"
       aria-hidden="true">
  </div>

  <!-- Drawer panel -->
  <div id="myce-mobile-nav-drawer"
       class="myce-mobile-nav"
       [class.myce-mobile-nav--open]="isOpen"
      role="navigation"
       aria-label="Mobile navigation">

    <!-- ── Main nav (hidden when a nav sub-panel or lang panel is open) ────────────────── -->
    <ng-container *ngIf="activeDrillDownIndex < 0 && !isLangPanelOpen">
      <!-- Menu title -->
      <div class="myce-mobile-nav__menu-title-row">
        <p class="myce-mobile-nav__menu-title">
          <span class="english">My Classroom Economy</span>
          <span class="spanish hidden">Mi Econom&#237;a en el Aula</span>
        </p>
      </div>

      <nav aria-label="Mobile primary navigation">
        <ul class="myce-mobile-nav__list" role="list">

          <li *ngFor="let item of navItems; let i = index; trackBy: trackByLabel"
              class="myce-mobile-nav__item">

            <!-- Plain link -->
            <a *ngIf="!item.hasDropdown && item.routeKey"
               [routerLink]="('/' + item.routeKey) | langLink"
               class="myce-mobile-nav__link"
               [routerLinkActive]="'myce-mobile-nav__link--active'"
               [ariaCurrentWhenActive]="'page'"
               (click)="close()">
              <span class="english">{{ item.labelEn }}</span>
              <span class="spanish hidden">{{ item.labelEs }}</span>
            </a>

            <!-- Drill-down trigger (replaces accordion) -->
            <button *ngIf="item.hasDropdown"
                    type="button"
                    class="myce-mobile-nav__link myce-mobile-nav__link--accordion"
                  aria-haspopup="true"
                    [attr.aria-expanded]="activeDrillDownIndex === i"
                    [attr.aria-controls]="'myce-mobile-nav-subpanel-' + i"
                    (click)="drillDown(i)">
              <span class="english">{{ item.labelEn }}</span>
              <span class="spanish hidden">{{ item.labelEs }}</span>
              <img class="myce-mobile-nav__caret"
                    src="/assets/icons/chevron-right.svg"
                   aria-hidden="true" alt="" />
            </button>
          </li>
        </ul>
      </nav>

      <!-- Contact us link -->
      <div class="myce-mobile-nav__contact-section">
        <a [routerLink]="'/aboutus' | langLink"
           [queryParams]="{contact: 'true'}"
           class="myce-mobile-nav__contact-link"
           [routerLinkActive]="'myce-mobile-nav__contact-link--active'"
           [routerLinkActiveOptions]="{paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored'}"
           (click)="close()">
          <span class="english">Contact us</span>
          <span class="spanish hidden">Cont&#225;ctenos</span>
        </a>
      </div>

      <!-- Language selector row — drill-down trigger -->
      <div class="myce-mobile-nav__lang-section">
        <button type="button"
                class="myce-mobile-nav__lang-row"
          aria-haspopup="true"
                [attr.aria-expanded]="isLangPanelOpen"
                aria-controls="myce-mobile-nav-lang-panel"
                (click)="openLangPanel()">
          <span class="myce-mobile-nav__lang-row-left">
            <img src="/assets/images/icons/language-selector.svg"
                 class="myce-mobile-nav__lang-icon"
                 aria-hidden="true" alt="" />
            <span>{{ currentLang === 'en' ? 'English' : 'Espa&#241;ol' }}</span>
          </span>
          <img class="myce-mobile-nav__caret"
               src="/assets/icons/chevron-right.svg"
               aria-hidden="true" alt="" />
        </button>
      </div>

      <!-- Log in — direct link to MCE login (new tab) -->
      <div class="myce-mobile-nav__login-section">
        <a *ngIf="loginItem as item"
          [href]="item.href"
           target="_blank"
           rel="noopener noreferrer"
           class="myce-mobile-nav__login-btn"
           (click)="close()">
          <span class="english">Log in</span>
          <span class="spanish hidden">Iniciar sesi&#243;n</span>
        </a>
      </div>
    </ng-container>

    <!-- ── Language sub-panel ───────────────────────────────────────────────────── -->
    <ng-container *ngIf="isLangPanelOpen">
      <div id="myce-mobile-nav-lang-panel" role="group" aria-labelledby="myce-mobile-nav-lang-title">
      <!-- Back button -->
      <div class="myce-mobile-nav__back-row">
        <button type="button"
                class="myce-mobile-nav__back-btn"
                (click)="closeLangPanel()">
          <svg class="myce-mobile-nav__back-icon" aria-hidden="true" focusable="false"
               viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="english">Back</span>
          <span class="spanish hidden">Atr&#225;s</span>
        </button>
      </div>

      <!-- Sub-panel title -->
      <div class="myce-mobile-nav__sub-panel-title-row">
        <p id="myce-mobile-nav-lang-title" class="myce-mobile-nav__sub-panel-title">
          <span class="english">Language</span>
          <span class="spanish hidden">Idioma</span>
        </p>
      </div>

      <!-- Language options -->
      <nav aria-label="Language selection">
        <ul class="myce-mobile-nav__sub-panel-list" role="list">
          <li class="myce-mobile-nav__sub-panel-item">
            <button type="button"
                    class="myce-mobile-nav__sub-panel-link"
                    [class.myce-mobile-nav__sub-panel-link--active]="currentLang === 'en'"
                    (click)="onLanguageClick('en')">
              English
            </button>
          </li>
          <li class="myce-mobile-nav__sub-panel-item">
            <button type="button"
                    class="myce-mobile-nav__sub-panel-link"
                    [class.myce-mobile-nav__sub-panel-link--active]="currentLang === 'es'"
                    (click)="onLanguageClick('es')">
              Espa&#241;ol
            </button>
          </li>
        </ul>
      </nav>
      </div>
    </ng-container>

    <!-- ── Nav sub-panel (Figma node 4:1734) — shown when a dropdown item is selected ── -->
    <ng-container *ngIf="activeDrillDownItem as item">
      <div [id]="'myce-mobile-nav-subpanel-' + activeDrillDownIndex" role="group" [attr.aria-labelledby]="'myce-mobile-nav-subpanel-title-' + activeDrillDownIndex">
      <!-- Back button -->
      <div class="myce-mobile-nav__back-row">
        <button type="button"
                class="myce-mobile-nav__back-btn"
                (click)="drillUp()">
          <svg class="myce-mobile-nav__back-icon" aria-hidden="true" focusable="false"
               viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="english">Back</span>
          <span class="spanish hidden">Atr&#225;s</span>
        </button>
      </div>

      <!-- Sub-panel title -->
      <div class="myce-mobile-nav__sub-panel-title-row">
        <p [id]="'myce-mobile-nav-subpanel-title-' + activeDrillDownIndex" class="myce-mobile-nav__sub-panel-title">
          <span class="english">{{ item.labelEn }}</span>
          <span class="spanish hidden">{{ item.labelEs }}</span>
        </p>
      </div>

      <!-- Sub-panel links -->
      <nav class="myce-mobile-nav__sub-panel-nav" aria-label="Sub navigation">
        <ul class="myce-mobile-nav__sub-panel-list" role="list">
          <li *ngFor="let child of item.dropdownItems; trackBy: trackByLabel"
              class="myce-mobile-nav__sub-panel-item">
            <a *ngIf="child.routeKey && !child.isExternal"
               [routerLink]="('/' + child.routeKey) | langLink"
               [queryParams]="child.queryParams || {}"
               class="myce-mobile-nav__sub-panel-link"
               [routerLinkActive]="'myce-mobile-nav__sub-panel-link--active'"
               [routerLinkActiveOptions]="{paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored'}"
               (click)="close()">
              <span class="english">{{ child.labelEn }}</span>
              <span class="spanish hidden">{{ child.labelEs }}</span>
            </a>
            <a *ngIf="child.isExternal"
               [href]="child.href"
               target="_blank"
               rel="noopener noreferrer"
               class="myce-mobile-nav__sub-panel-link"
               (click)="close()">
              <span class="english">{{ child.labelEn }}</span>
              <span class="spanish hidden">{{ child.labelEs }}</span>
            </a>
          </li>
        </ul>
      </nav>
      </div>
    </ng-container>

  </div>
</ng-container>
